var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgE(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.175 16.561",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    className: "cls-1",
    d: "M13.967,10.93l1.711.883a9.141,9.141,0,0,1-1.932,2.65,7.246,7.246,0,0,1-2.484,1.546,9.064,9.064,0,0,1-3.091.552,7.454,7.454,0,0,1-6.017-2.539A8.641,8.641,0,0,1,0,8.281,8.608,8.608,0,0,1,1.822,2.926,7.621,7.621,0,0,1,8.06,0a7.725,7.725,0,0,1,6.4,3.036,8.2,8.2,0,0,1,1.711,5.355H2.1a6.3,6.3,0,0,0,1.767,4.471,5.625,5.625,0,0,0,4.2,1.767,6.65,6.65,0,0,0,2.319-.442,6.554,6.554,0,0,0,1.932-1.1A8.554,8.554,0,0,0,13.967,10.93Zm0-4.251a7.076,7.076,0,0,0-1.159-2.595,5.282,5.282,0,0,0-2.043-1.546,6.213,6.213,0,0,0-2.65-.607A5.736,5.736,0,0,0,4.14,3.423,6.878,6.878,0,0,0,2.263,6.68Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE);
export default __webpack_public_path__ + "static/media/e.403a976fee994c49c9132c1bb0c031e2.svg";
export { ForwardRef as ReactComponent };